export default __webpack_public_path__ + "static/cruiselines-royal-activities-1-74064cf998b289aa4a5a004ca4e29319.jpg";